import { useEffect, useState } from 'react'
import { ButtonSubmit } from '../../../../GlobalStyle'
import { Mask } from '../../../../hooks/Mask'
import { reverseFormatMoney } from '../../../../hooks/removeFormat'
import InputComponent from '../../Input'
import SelectOptions from '../../Select'
import Base from '../index'
import { ModalDivInput } from './style'

const ModalEditComponent = ({ callBack, prod }) => {
  const [name, setName] = useState(prod.nome)
  const [quantity, setQuantity] = useState(prod.quantidade)
  const [price, setPrice] = useState(Mask.money(prod.valor))
  const [priceByUnity, setPriceByUnity] = useState(0)
  const [unity, setUnity] = useState(prod.unidade)

  useEffect(() => {
    setPriceByUnity(reverseFormatMoney(price) / quantity)
  }, [price, quantity])

  return (
    <Base
      title={'Edição de componentes'}
      width={'30%'}
      height={'70%'}
      minHeight={'450px'}
      minWidth={'300px'}
    >
      <ModalDivInput>
        <InputComponent
          value={name}
          onChange={(e) => setName(e.target.value)}
          label={'Nome'}
        ></InputComponent>

        <SelectOptions unity={unity} setUnity={setUnity} />

        <InputComponent
          value={quantity}
          onChange={(e) => setQuantity(Mask.onlyDigits(e.target.value))}
          label={'Fração'}
        ></InputComponent>
        <InputComponent
          value={price}
          onChange={(e) => setPrice(Mask.money(e.target.value))}
          label={'Preço'}
        ></InputComponent>
        <InputComponent
          value={Mask.money(priceByUnity)}
          disabled
          label={'Preço por unidade'}
        ></InputComponent>
      </ModalDivInput>
      <ButtonSubmit
        margin={'0px'}
        onClick={() =>
          callBack({
            id: parseInt(prod.id),
            nome: name,
            quantidade: parseInt(quantity),
            unidade: unity,
            valor: reverseFormatMoney(price),
          })
        }
      >
        Salvar
      </ButtonSubmit>
    </Base>
  )
}
export default ModalEditComponent
